"use client";

import { Box, Typography } from "@mui/material";

export function PrivacyPage() {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: "white",
        maxWidth: "800px",
        margin: "0 auto",
        padding: 2,
        h4: theme.typography.h4,
        "& p": {
          ...theme.typography.body1,
          margin: theme.spacing(1, 0),
        },
        ul: {
          ...theme.typography.body1,
          paddingLeft: theme.spacing(4),
          marginBottom: theme.spacing(2),
        },
      })}
    >
      <Typography variant="h4" component="h1">
        Privacy Policy
      </Typography>
      <p>
        In accordance with the Privacy Act 1988 (as amended by the Privacy
        Amendment (Private Sector) Act 2000) (Commonwealth) Horsezone.com.au is
        required to comply with the 10 National Privacy Principles.
      </p>
      <p>
        Horsezone.com.au takes its obligations under the Privacy Act seriously
        and will take all reasonable steps to comply with the Act and protect
        the privacy of the personal information that we hold.
      </p>
      <p>
        The Horsezone.com.au Privacy Policy applies for all commercial
        transactions with the company, when you subscribe to our email program
        or visit our Internet sites.
      </p>
      <p>
        We will endeavour to ensure that we handle your personal information
        securely and will only use your personal information when it is
        necessary for us to deliver you a service or perform other necessary
        business functions and activities.
      </p>
      <p>
        Horsezone.com.au will not use your information for purposes unrelated to
        the services we provide, unless we first obtain your consent.
      </p>

      <Typography variant="h6" component="h2">
        Collection
      </Typography>
      <p>
        We will always use fair and lawful means of collecting personal
        information. In most circumstances we will collect personal information
        directly from you.
      </p>
      <p>
        Some information provided to us by clients, customers, contractors and
        other third parties might be considered private or personal. Without
        these details we would not be able to carry on our business and provide
        our services to you. We will only collect such personal information if
        it is necessary for one of our business functions or activities.
      </p>
      <p>
        Different personal information is collected for different reasons,
        including:
      </p>
      <ul>
        <li>Completing transactions with you or on your behalf </li>
        <li>Delivering products or services to you </li>
        <li>Protecting against fraud or theft </li>
        <li>Better understanding your requirements and preferences </li>
      </ul>
      <p>
        The personal information we collect is in most cases supplied when
        customers register their details, or provide feedback to us.
      </p>
      <p>
        Generally, the information we collect includes customer name, address,
        delivery address, phone number and other contact details (fax, email
        etc), and method of payment including bank account details. By obtaining
        the above information, we can complete transactions and communicate with
        you.
      </p>

      <Typography variant="h6" component="h2">
        Disclosure
      </Typography>
      <p>
        Horsezone.com.au believes that your personal information, including your
        purchase history, email and residential addresses, and financial
        information belongs to you. To service you better, we collect this type
        of information when you provide it to us, but we do not rent, sell or
        trade your personal information to others without your consent.
      </p>
      <p>
        From time to time your personal details will need to be passed on to
        third party data entry companies, email marketing companies and
        consultants who perform parts of our service delivery, as part of our
        legitimate business operation, such as couriers, technical partners,
        email providers, web hosts, related third party data entry companies,
        email marketing companies and consultants, some of whom may be located
        outside of Australia.
      </p>
      <Typography variant="h6" component="h2">
        Cookies
      </Typography>
      <p>
        Cookies are pieces of information that are transferred to your
        computer&apos;s hard drive via your Web browser. Horsezone.com.au does not
        use cookies.
      </p>
      <Typography variant="h6" component="h2">
        Security
      </Typography>
      <p>
        Horsezone.com.au will take all reasonable steps to store your personal
        information securely. Personal information is destroyed securely when no
        longer required by us. Information stored within our computer systems
        can only be accessed by those with delegated authority and if
        authenticated with a valid network userid and password.
      </p>
      <Typography variant="h6" component="h2">
        Access
      </Typography>
      <p>
        Horsezone.com.au is committed to maintaining accurate, timely and
        relevant information. Any requests to access or update your personal
        information, in line with the National Privacy Principles, should be
        submitted in writing to: support@horsezone.com.au
      </p>
      <Typography variant="h6" component="h2">
        Further Information
      </Typography>
      <p>
        From time to time our privacy policy and procedures will be reviewed and
        if appropriate updated.
      </p>
      <p>
        Further information on the National Privacy Principles can be found on
        the Federal Privacy Commissioner&apos;s web-site at
        <a href="http://www.privacy.gov.au">www.privacy.gov.au</a>
      </p>

      <Typography variant="h6" component="h2">
        Data Deletion
      </Typography>
      <p>
        Send an email request to support@horsezone.com.au from your registered
        email address. Horsezone will process the removal and securely destroy
        or de-identify your personal information in compliance with privacy
        obligations.
      </p>
    </Box>
  );
}
